import React from "react";
import { connect } from "react-redux";

const ButtonModule = (props) => {
  const { clientKey, template } = props;
  const { url, openInNewWindow, displayText, backgroundColor, color, borderRadius, borderColor, borderWidth, fontSize, useTemplateStyle } = props.settings;
  const buttonStyle = {
    padding: "6px 12px",
    minWidth: "50px",
    width: "100%",
    height: "auto",

    backgroundColor: backgroundColor != "unset" && useTemplateStyle ? backgroundColor : template.button.backgroundColor,
    borderRadius: borderRadius != "unset" && useTemplateStyle ? borderRadius : template.button.borderRadius,
    color: color != "unset" && useTemplateStyle ? color : template.button.color,
    padding: "6px 12px 6px 12px",
    /* "&:hover": {
      backgroundColor: "pink",
      color: "#eee",
    }, */
    borderColor: borderColor != "unset" && useTemplateStyle ? borderColor : template.button.borderColor,
    fontSize: fontSize != "unset" && useTemplateStyle ? fontSize : template.button.fontSize,
    borderWidth: borderWidth != "unset" && useTemplateStyle ? borderWidth : template.button.borderWidth,
    borderStyle: borderWidth != "unset" && useTemplateStyle ? "solid" : undefined,
  };

  let formattedUrl = url;
  if (url)
    formattedUrl = url
      .toString()
      .replace(/\[clientkey\]/gi, clientKey)
      .replace(/\[badgeno\]/gi, clientKey);

  if (formattedUrl && !formattedUrl.includes("http") && !formattedUrl.includes('mailto')) formattedUrl = "https://" + formattedUrl;

  if (window.location.toString().includes("localhost") && !formattedUrl.includes("localhost") && formattedUrl.includes("jirango.com/interaction")) {
    formattedUrl = formattedUrl.replace("jirango.com/interaction", "localhost:44352");
  }
  return (
    <button onClick={() => props.preview ? null : window.open(formattedUrl, openInNewWindow ? "_blank" : "_self")} dangerouslySetInnerHTML={{__html: displayText}} style={template ? { ...template.button, ...buttonStyle } : {}}>
    </button>
  );
};

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : undefined,
  };
}
export default connect(mapStateToProps)(ButtonModule);
